import { render, staticRenderFns } from "./CardImgPosition.vue?vue&type=template&id=3541e4e4"
import script from "./CardImgPosition.vue?vue&type=script&lang=js"
export * from "./CardImgPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports